import { FC } from "react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import GraphCanvasOntology from "modules/ontology/pages/create-ontology-entities-relationships/components/graph-canvas/GraphCanvasOntology";
import {
  GraphNode,
  GraphEdge
} from "modules/ontology/data/ontology-graph.model";
import "./RelatedEntitiesGraph.scss";

interface RelatedEntitiesGraphOverlayProps {
  subGraph: { nodes: GraphNode[]; edges: GraphEdge[] };
  focusedNodeId: string | null;
  focusedNodeLabel: string | null;
  focusedNodeType: string | null;
  connectedCount: number;
  isDrilling: boolean;
  // The node single-clicked inside this overlay (for the Graph Directory's detail panel),
  // kept separate from focusedNodeId so clicking a node doesn't re-center the ego-graph ring.
  selectedNodeId: string | null;
  onNodeDoubleClick: (nodeId: string) => void;
  onNodeSelect: (nodeId: string) => void;
  onClose: () => void;
}

// Floating "ego graph" canvas shown on top of the main Graph View canvas after a
// double-click; double-clicking a node here drills into it (via the same `open` action,
// scoped to this overlay only) instead of affecting the main canvas underneath.
const RelatedEntitiesGraphOverlay: FC<RelatedEntitiesGraphOverlayProps> = ({
  subGraph,
  focusedNodeId,
  focusedNodeLabel,
  focusedNodeType,
  connectedCount,
  isDrilling,
  selectedNodeId,
  onNodeDoubleClick,
  onNodeSelect,
  onClose
}) => {
  return (
    <div className="create-entities-related-entities-graph-overlay">
      <div className="create-entities-related-entities-graph-overlay__canvas">
        {focusedNodeLabel && (
          <div className="create-entities-related-entities-graph-overlay__context">
            <div className="create-entities-related-entities-graph-overlay__context-heading">
              <span className="create-entities-related-entities-graph-overlay__context-name">
                {focusedNodeLabel}
              </span>
              {focusedNodeType && (
                <span className="create-entities-related-entities-graph-overlay__context-type">
                  {focusedNodeType}
                </span>
              )}
            </div>
            <p className="create-entities-related-entities-graph-overlay__context-subtitle">
              Focused view · {connectedCount} directly connected node
              {connectedCount === 1 ? "" : "s"}
            </p>
          </div>
        )}
        <GraphCanvasOntology
          nodes={subGraph.nodes}
          edges={subGraph.edges}
          selectedNodeId={focusedNodeId}
          selectedDetailNodeId={selectedNodeId}
          onNodeSelect={onNodeSelect}
          onNodeDoubleClick={onNodeDoubleClick}
          layout="circular"
          scrollZoom
        />
        {isDrilling && (
          <div className="create-entities-related-entities-graph-overlay__drilling">
            Loading…
          </div>
        )}
      </div>
    </div>
  );
};

export default RelatedEntitiesGraphOverlay;
